var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMk3Select(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11734 3.12778C8.03214 3.17039 7.91853 3.27453 7.87119 3.35027C7.78598 3.49228 7.78125 3.84257 7.78125 14.6923C7.78125 25.7124 7.78125 25.8923 7.87592 26.039C8.11734 26.4367 8.728 26.4319 8.99308 26.0248C9.07356 25.9065 9.07829 25.5893 9.06409 20.6047L9.04989 15.3077L9.1635 15.2603C9.2203 15.2319 12.7091 14.2142 16.9126 12.9929C25.2487 10.5645 24.7564 10.7301 24.8747 10.3325C24.941 10.1148 24.8747 9.88281 24.6901 9.70766C24.5339 9.56092 8.61912 3.04731 8.41557 3.04731C8.33983 3.04731 8.20729 3.08518 8.11734 3.12778Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk3Select);
export default __webpack_public_path__ + "static/media/mk3_select.6ed6f8ab458394312bd0d93d4c43b73f.svg";
export { ForwardRef as ReactComponent };